import React from 'react'
import TabLinkUI from '../../../widgets/output/TabLinkUI'

const AllIncomeNavUI = ({ context, page }) =>
    <div>
        <div className='g_flex_h g_flex_left g_flex_wrap'>
            <TabLinkUI label='Yearly' to='/su/income' active={page === 'yearly'} />
            <TabLinkUI label='Monthly' to='/su/income/monthly' active={page === 'monthly'} />
        </div>
        <div className='g_m_top_50' />
    </div>

export default AllIncomeNavUI